module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av493-77c98637f7b31fc2cd58e60d9ef8690f.jpg";